export default __webpack_public_path__ + "static/media/refresh.ef92b049.svg";